import { createSelector } from 'reselect'

import {
  inviteeSelector as inviteeFromQuerySelector,
  rescheduledInviteeSelector as rescheduledInviteeFromQuerySelector
} from 'root-api'

export const currentInviteeSelector = createSelector(
  inviteeFromQuerySelector,
  rescheduledInviteeFromQuerySelector,
  (query, rescheduledQuery) => rescheduledQuery || query
)

export const isReschedulingSelector = createSelector(
  currentInviteeSelector,
  (currentInvitee) => !!currentInvitee
)

export const inviteeTimezoneSelector = createSelector(
  currentInviteeSelector,
  (currentInvitee) => currentInvitee && currentInvitee.timezone
)
